
  $('.trigger_video_play_js').click(function(){
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if ($(this).hasClass("active")) {
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
    jQuery(this).addClass('active');
}
});

   $('.trigger_custom_tab').click(function(){
        var current_tab = $(this).attr('data_tab');
        $(this).parents('.collection').find('.trigger_custom_tab').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.collection').find('.tab_content').hide();
        $(this).parents('.collection').find('.tab_content[data_tab="'+current_tab+'"]').show();
      $(this).parents('.collection').find('.tab_content[data_tab="'+current_tab+'"] ul.product-grid').slick('refresh');
    });


 $('.footer-block.grid__item.footer-block--menu h2.footer-block__heading.inline-richtext').click(function(){
    jQuery(this).toggleClass('active');
});

   $('.button_open_custom').click(function(){
        var current_tab = $(this).attr('data_id');
        $('.custom_popup_main').hide();
        $('.custom_popup_main[data_id="'+current_tab+'"]').show();
    });
    
   $('.custom_popup_bg, .custom_popup_close').click(function(){
        $('.custom_popup_main').hide();
    });
/*
    $('.trigger_tabs_flex').slick({
  dots: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  infinite: false,
  cssEase:'linear',
  prevArrow:'<button class="slick-arrow slick-prev" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none"><path d="M9.00195 16.5L1.50195 9L9.00195 1.5" stroke="#0F0E0E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="slick-arrow slick-next" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_475_3911)"><path d="M8 4.5L15.5 12L8 19.5" stroke="#0F0E0E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_475_3911"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></button>',
 
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1, 
        slidesToScroll: 1, 
      }
    }
  ]
});*/
    
    $('.tabs_custom').slick({
  dots: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  infinite: false,
  cssEase:'linear',
  prevArrow:'<button class="slick-arrow slick-prev" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none"><path d="M9.00195 16.5L1.50195 9L9.00195 1.5" stroke="#0F0E0E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="slick-arrow slick-next" style="display:none;"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g clip-path="url(#clip0_475_3911)"><path d="M8 4.5L15.5 12L8 19.5" stroke="#0F0E0E" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_475_3911"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></button>',
 
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2, 
        slidesToScroll: 1, 
      }
    }
  ]
});







class Accordion {
constructor(el) {
// Store the <details> element
this.el = el;
// Store the <summary> element
this.summary = el.querySelector('summary');
// Store the <div class="content"> element
this.content = el.querySelector('.accordion__content');

// Store the animation object (so we can cancel it if needed)
this.animation = null;
// Store if the element is closing
this.isClosing = false;
// Store if the element is expanding
this.isExpanding = false;
// Detect user clicks on the summary element
this.summary.addEventListener('click', (e) => this.onClick(e));
}

onClick(e) {
// Stop default behaviour from the browser
e.preventDefault();
// Add an overflow on the <details> to avoid content overflowing
this.el.style.overflow = 'hidden';
// Check if the element is being closed or is already closed
if (this.isClosing || !this.el.open) {
this.open();
// Check if the element is being openned or is already open
} else if (this.isExpanding || this.el.open) {
this.shrink();
}
}

shrink() {
// Set the element as "being closed"
this.isClosing = true;

// Store the current height of the element
const startHeight = `${this.el.offsetHeight}px`;
// Calculate the height of the summary
const endHeight = `${this.summary.offsetHeight}px`;

// If there is already an animation running
if (this.animation) {
// Cancel the current animation
this.animation.cancel();
}

// Start a WAAPI animation
this.animation = this.el.animate({
// Set the keyframes from the startHeight to endHeight
height: [startHeight, endHeight]
}, {
duration: 300,
easing: 'linear'
});

// When the animation is complete, call onAnimationFinish()
this.animation.onfinish = () => this.onAnimationFinish(false);
// If the animation is cancelled, isClosing variable is set to false
this.animation.oncancel = () => this.isClosing = false;
}

open() {
// Apply a fixed height on the element
this.el.style.height = `${this.el.offsetHeight}px`;
// Force the [open] attribute on the details element
this.el.open = true;
// Wait for the next frame to call the expand function
window.requestAnimationFrame(() => this.expand());
}

expand() {
// Set the element as "being expanding"
this.isExpanding = true;
// Get the current fixed height of the element
const startHeight = `${this.el.offsetHeight}px`;
// Calculate the open height of the element (summary height + content height)
const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

// If there is already an animation running
if (this.animation) {
// Cancel the current animation
this.animation.cancel();
}

// Start a WAAPI animation
this.animation = this.el.animate({
// Set the keyframes from the startHeight to endHeight
height: [startHeight, endHeight]
}, {
duration: 300,
easing: 'linear'
});
// When the animation is complete, call onAnimationFinish()
this.animation.onfinish = () => this.onAnimationFinish(true);
// If the animation is cancelled, isExpanding variable is set to false
this.animation.oncancel = () => this.isExpanding = false;
}

onAnimationFinish(open) {
// Set the open attribute based on the parameter
this.el.open = open;
// Clear the stored animation
this.animation = null;
// Reset isClosing & isExpanding
this.isClosing = false;
this.isExpanding = false;
// Remove the overflow hidden and the fixed height
this.el.style.height = this.el.style.overflow = '';
}
}

document.querySelectorAll('details').forEach((el) => {
new Accordion(el);
});


jQuery('span#ProductPopup2').click(function(e){
 jQuery('.product__info-container .product-popup-modal__opener button').trigger('click');
});

$(document).on("change", 'select#sticky-variant-selector', function(event) { 
var text = $('select#sticky-variant-selector :selected').text();
 text = text.trim();
$('variant-selects input[value="'+text+'"]+label').trigger('click');
//$("#stikcy_price_refresh_main").load(location.href + " #stikcy_price_refresh");
//$("#atc-price").load(location.href + " #atc-price_refresh");
//$("#atc-compare-price").load(location.href + " #atc-compare-price_refresh");
});

$(document).on("change", '.product-form__input--pill input[type=radio]', function(event) { 
var id = $('.buy_buttons_custom input.product-variant-id').val();
$('select#sticky-variant-selector').val(id);
updateStickyPrice();
//$("#stikcy_price_refresh_main").load(location.href + " #stikcy_price_refresh");
//$("#atc-price").load(location.href + " #atc-price_refresh");
//$("#atc-compare-price").load(location.href + " #atc-compare-price_refresh");
});





$(document).ready(function () {
  const label = $('.variants_picker_custom .product-form__input--pill label:nth-child(4)');
  if (!label.length) return;

  let lockScroll = true;

  const holdTop = setInterval(() => {
    if (lockScroll) window.scrollTo(0, 0);
  }, 10);

  label.trigger('click');
  updateStickyPrice();

  setTimeout(() => {
    lockScroll = false;
    clearInterval(holdTop);
    window.scrollTo(0, 0);
  }, 300);
});



function updateStickyPrice() {
    var selectedOption = $('select#sticky-variant-selector').find('option:selected');
    var price = selectedOption.data('price');
    var comparePrice = selectedOption.data('compare-price');
    var save_price = selectedOption.data('save-price');

    $("#stikcy_price_refresh").hide();

    setTimeout(function() {
        $("#stikcy_price_refresh").find(".price-item--regular").html(price);
        $("#stikcy_price_refresh").find(".price-item--sale").html(comparePrice);
       $("#atc-price").html(price);
       $("#atc-compare-price").html(comparePrice);

        if(save_price != ''){
        $("#stikcy_price_refresh").find('.save_sticky').text('SPARE ' + save_price);
        $("#stikcy_price_refresh").find('.save_sticky').show();
        }else{
        $("#stikcy_price_refresh").find('.save_sticky').hide();
         }
        $("#stikcy_price_refresh").show();
    }, 500);
}

// Trigger on variant change
$(document).on("change", 'select#sticky-variant-selector', function() { 
    updateStickyPrice();
});

